import Vue from 'vue'
import requisitionTransformer from '../../transformers/purchase/requisition'

export default (camp) => Vue.$http.get(`catalogs/providers/?camp=${camp}&business=5`)
  .then((response) => {
    const data = response.data

    return data
  })


// WEBPACK FOOTER //
// ./src/services/purchase/fetchProviders.js